import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';

@autoinject
export class HoursToDaysValueConverter {
  constructor(private t: I18N) {}

  toView(value?: number | string | null): string | null {
    if (value === null || value === undefined) {
      return null;
    }

    value = +value; // Ensure value is a number

    if (isNaN(value)) {
      return null;
    }

    value = Math.max(value, 0);

    const days = Math.floor(value / 24);
    const hours = value % 24;
    const parts = [];
    if (days > 0) {
      parts.push(`${days} ${days === 1 ? this.t.tr('general.day') : this.t.tr('general.days')}`);
    }
    if (hours > 0 || parts.length === 0) {
      parts.push(`${hours} ${hours === 1 ? this.t.tr('general.hour') : this.t.tr('general.hours')}`);
    }

    return parts.join(', ');
  }
}
